import { ReactElement } from 'react';

import {
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';
import { ModalCancelButton, ModalCloseButton, ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { dischargeSummaryTranslationKeys } from '../../../translations';

import { MedicalFieldSelectForm } from './MedicalFieldSelectForm';
import { MedicalFieldSaveAndContinueModalConfirmButton } from './MedicalFieldSaveAndContinueModalConfirmButton';

type MedicalFieldVerificationShowModalEventInterceptorProps = {
   serviceProvidingLocationId: number;
   children: ReactElement;
};

export const MedicalFieldVerificationShowModalEventInterceptor = (
   props: MedicalFieldVerificationShowModalEventInterceptorProps
): ReactElement => {
   const shouldShowModal = async (): Promise<boolean> => {
      const serviceProvidingLocation = await performCqrsQueryGet<ServiceProvidingLocation>(() => {
         const query = new ServiceProvidingLocationForCurrentPracticeQuery();
         query.id = Slot.of(props.serviceProvidingLocationId);
         return query;
      });
      return !serviceProvidingLocation.medicalField;
   };

   return (
      <ShowModalEventInterceptor
         testId={'medicalFieldVerification'}
         shouldShowModal={shouldShowModal}
         title={dischargeSummaryTranslationKeys.missingConfigurationData}
         modalWidth={ModalWidth.NORMAL}
         content={({ resolve, reject }) => (
            <MedicalFieldSelectForm>
               {({ handleSubmit, formState }) => (
                  <>
                     <MedicalFieldSaveAndContinueModalConfirmButton
                        handleSubmit={handleSubmit}
                        onSuccess={resolve}
                        serviceProvidingLocationId={props.serviceProvidingLocationId}
                     />
                     <ModalCancelButton onClick={reject} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={reject} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </MedicalFieldSelectForm>
         )}
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
